import {
  IonIcon,
  IonItemDivider,
  IonLabel,
  IonRippleEffect,
} from '@ionic/react';
import { usePlot } from '@lidea/shared/data-access/plots';
import { Text } from '@mantine/core';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { checkmarkCircle, chevronDown, chevronForward } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';

dayjs.extend(relativeTime);

interface FieldItemProps {
  fieldId: number;
  lastUpdated?: number;
  status: 'pending' | 'success' | 'error' | 'paused';
  onClick: () => void;
  expanded: boolean;
}

export const FieldItem: React.FC<FieldItemProps> = ({
  lastUpdated,
  fieldId,
  onClick,
  expanded,
}) => {
  const { t } = useTranslation(['common'], { useSuspense: false });
  const field = usePlot(fieldId);
  return (
    <IonItemDivider
      // lines="full"
      className="ion-activatable ripple-parent rectangle ion-relative"
      style={{
        '--margin-bottom': '8px',
        '--margin-top': '8px',
        '--padding-start': '0px',
        '--inner-padding-start': '16px',
        position: 'relative',
        color: 'black',
      }}
      onClick={onClick}
    >
      <IonLabel>
        <Text fw="bold" lineClamp={1} size="lg" truncate>
          {field.data?.properties.name} - {field.data?.properties.farm.name}
        </Text>
        {lastUpdated ? (
          <Text>
            {t('common:last_update')} {dayjs().to(lastUpdated)}
          </Text>
        ) : null}
      </IonLabel>
      <IonIcon color="success" icon={checkmarkCircle} slot="end" />
      <IonIcon
        color="gray"
        icon={expanded ? chevronDown : chevronForward}
        size="small"
        slot="end"
      />
      <IonRippleEffect />
    </IonItemDivider>
  );
};
